var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-page"},[_c('div',[_c('div',{staticClass:"digits"},[_vm._v("404")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("Сторінку не знайдено. Перейти на "),_c('router-link',{attrs:{"to":{ name: 'home'}}},[_vm._v("головну")]),_vm._v(".")],1)]),_vm._v(" "),_c('div',{staticClass:"fake-footer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a98b5f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/NotFoundPage.vue
// module id = 804
// module chunks = 1